import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Tarification intelligente',
  master_title: 'Mode marque - Tarification intelligente',
  sections: {
    how_it_works: {
      title: 'Comment ça fonctionne',
      description:
        'La tarification intelligente vous permet de contrôler vos prix selon le mode de commande du client. Elle couvre de nombreux cas : réduction pour le retrait, majoration pour la livraison, remise sur le menu saisonnier, etc. Vous pouvez créer des règles à plusieurs niveaux (Global, Menu, Catégorie, Produit, Groupe de modificateurs, Modificateur). Les niveaux fonctionnent comme un arbre : le niveau supérieur affecte les niveaux inférieurs, mais une règle de niveau inférieur a la priorité sur celle du niveau supérieur (ex. : une remise retrait de 5% sur une catégorie écrase la remise retrait globale de 15% pour ses produits).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Règles globales',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Règles globales',
    [menus_tab]: 'Règles de menu',
    [categories_tab]: 'Règles de catégorie',
    [products_tab]: 'Règles de produit',
    [modifier_groups_tab]: 'Règles de groupe de modificateurs',
    [modifiers_tab]: 'Règles de modificateurs',
  },
  fields: {
    name: 'Nom',
    order_methods: 'Modes de commande',
    modifier: 'Modificateur',
    image: 'Image',
    actions: 'Actions',
  },
  labels: {
    absolute: 'Absolu',
  },
  buttons: {
    add_rule: 'Ajouter une règle',
    edit: 'Modifier',
    delete: 'Supprimer ({{count}})',
    images: "Gérer l'image",
  },
  popups: {
    delete_rule: {
      title: 'Confirmer la suppression ?',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_delete: 'Échec de la suppression des règles',
    deleted_successfully: 'Règles supprimées avec succès',
  },
};
